var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-header"},[_c('div',{staticClass:"label"},[_c('span',[_vm._v("Your Cart ("+_vm._s(_vm.cartCount)+")")])]),_c('cart-close',{ref:"close",on:{"close":function($event){return _vm.closeCart()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }